import XLSX from 'xlsx';

import { BUExcel } from './BUExcelContent';
import { LLExcel } from './LLExcelContent';
import { CMExcel } from './CMExcelContent';
import { LRExcel } from './LRExcelContent';
import { CCMExcel } from './CCMExcelContent';
// import { CCMExcelTwo } from './CCMExcelContent';
import { LoadingConfirm } from './LoadingConfirmExcel';
import { SampleExcelContent } from './SampleExcel';
// import { TruckingRate } from './TruckerRate';

export function BuildUpExcel(data) {
    // console.log(data)
    BUExcel(XLSX, data)
}

export function LoadListExcel(data) {
    // console.log(data)
    LLExcel(XLSX, data)
}

export function CoastingManifest(data) {
    // console.log(data)
    CMExcel(XLSX, data)
}

export function LoadingReport(data) {
    // console.log(data)
    LRExcel(XLSX, data)
}

export function CargoCostingManifest(data) {
    // console.log(data)
    CCMExcel(XLSX, data);
    // CCMExcelTwo(XLSX, data);
}

export function LoadingConfirmExcel(data) {
    // console.log(data)
    LoadingConfirm(XLSX, data)
}

export function SampleExcel(data) {
    // console.log(data)
    SampleExcelContent(XLSX, data)
    // TruckingRate(XLSX, data)
}